import { Component } from '@angular/core';

@Component({
  selector: 'app-remove-rule-dialog',
  templateUrl: 'remove-rule-dialog.component.html',
  styleUrls: ['remove-rule-dialog.component.scss']
})
export class RemoveRuleDialogComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/remove-rule-dialog/remove-rule-dialog.component.ts